export class BusquedaAsamblea {
  public idAsamblea = 0;
  public idOrganizador = 0;
  public fechaRegistro = '';
  public estado = '';
}
